<template>
  <div class="page">
    <div class="page-main">
      <el-form
        class="page-card"
        ref="form"
        :model="form"
        :rules="rules"
        label-width="auto"
      >
        <el-form-item :label="$t('model.modelName')" prop="templateName">
          <el-input
            v-model="form.templateName"
            :maxlength="128"
            :placeholder="$t('model.modelNamePla')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('ssite.site')" prop="siteIds">
          <select-site
            v-model="form.siteIds"
            checkboxShow
            checkStrictly
          ></select-site>
        </el-form-item>
        <el-form-item :label="$t('model.model')" prop="modelName">
          <select-model
            v-model="form.modelName"
            :siteIds="form.siteIds"
          ></select-model>
        </el-form-item>
        <el-form-item :label="$t('model.description')">
          <el-input
            v-model="form.modelDesc"
            :placeholder="$t('model.descriptionPla')"
            :maxlength="500"
            type="textarea"
            :rows="6"
          ></el-input>
        </el-form-item>
        <el-form-item class="footer-btns">
          <el-button class="footer-btn" type="primary" plain @click="$router.push({ path: '/model' })">{{
            $t('cancel')
          }}</el-button>
          <el-button class="footer-btn" type="primary" @click="submit">{{
            $t('nextStep')
          }}</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { SelectModel, SelectSite } from '@/components'
import { modelAdd, modelUpdate, modelQuery } from '@/api/model'

export default {
  name: 'ModelDetails',
  components: { SelectModel, SelectSite },
  data() {
    return {
      form: {
        templateName: '',
        siteIds: [],
        modelName: '',
        modelDesc: '',
      },
      rules: {
        templateName: {
          required: true,
          message: this.$t('model.modelNameRule'),
          trigger: 'blur',
        },
        siteIds: {
          required: true,
          message: this.$t('ssite.siteRule'),
          trigger: 'change',
        },
        modelName: {
          required: true,
          message: this.$t('model.modelRule'),
          trigger: 'change',
        },
      },
    }
  },
  created() {
    this.$route.query.id && this.getData(this.$route.query.id)
    if (
      this.$route.query.templateName ||
      this.$route.query.site ||
      this.$route.query.modelName ||
      this.$route.query.modelDesc
    ) {
      this.form.templateName = this.$route.query.templateName
      this.form.siteIds = this.$route.query.site
      this.form.modelName = this.$route.query.modelName
      this.form.modelDesc = this.$route.query.modelDesc
    }
  },
  methods: {
    getData(id) {
      modelQuery({ id })
        .then(({ data }) => {
          const {
            id,
            templateName,
            siteIds,
            modelName,
            modelDesc,
          } = data.result.rows[0]
          this.$set(this, 'form', {
            id,
            templateName,
            siteIds,
            modelName,
            modelDesc,
          })
        })
        .catch(() => {})
    },
    // 保存
    submit() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          const submitApi = this.$route.query.id ? modelUpdate : modelAdd
          submitApi(this.form)
            .then(({ data }) => {
              this.$router.push({
                path: '/model/setParam',
                query: {
                  relationName: 'model',
                  id: this.$route.query.id
                    ? this.$route.query.id
                    : data.result.rows[0],
                  templateName: this.form.templateName,
                  site: this.form.siteIds,
                  deviceModel: this.form.modelName,
                  modelName: this.form.modelName,
                  modelDesc: this.form.modelDesc,
                },
              })
            })
            .catch(() => {})
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@include form-page;
.page-main {
  padding-top: 30px;
}
</style>
